var map = {
	"./bg.png": "0f1e",
	"./enterprise/1.png": "2caf",
	"./enterprise/10.png": "642c",
	"./enterprise/11.png": "80cc",
	"./enterprise/12.png": "4877",
	"./enterprise/13.png": "ad7a",
	"./enterprise/14.png": "5308",
	"./enterprise/15.png": "4e81",
	"./enterprise/16.png": "4f5e",
	"./enterprise/17.png": "1d47",
	"./enterprise/2.png": "375e",
	"./enterprise/3.png": "5d60",
	"./enterprise/4.png": "1080",
	"./enterprise/5.png": "5c24",
	"./enterprise/6.png": "dce7",
	"./enterprise/7.png": "5a3f",
	"./enterprise/8.png": "36fb",
	"./enterprise/9.png": "caba",
	"./platform/1.png": "6720",
	"./platform/10.png": "e786",
	"./platform/11.png": "d00d",
	"./platform/12.png": "911c",
	"./platform/13.png": "6dd5",
	"./platform/2.png": "47d4",
	"./platform/3.png": "f9d3",
	"./platform/4.png": "b629",
	"./platform/5.png": "a13a",
	"./platform/6.png": "9863",
	"./platform/7.png": "959d",
	"./platform/8.png": "797e",
	"./platform/9.png": "d45a",
	"./scientific/1.png": "997b",
	"./scientific/2.png": "1594",
	"./scientific/3.png": "fcb4",
	"./scientific/4.png": "66bd",
	"./scientific/5.png": "5f85",
	"./scientific/6.png": "01a5",
	"./scientific/7.png": "ff0e",
	"./scientific/8.png": "0416",
	"./university/1.png": "87b2",
	"./university/10.png": "04f5",
	"./university/11.png": "2985",
	"./university/2.png": "43623",
	"./university/3.png": "c694",
	"./university/4.png": "dad2",
	"./university/5.png": "d716e",
	"./university/6.png": "d3a8",
	"./university/7.png": "f414",
	"./university/8.png": "f895",
	"./university/9.png": "b8b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1062";